// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_syntax_tree = require("../mm-utils/MM_syntax_tree.bs.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");

function unsafeFunc(title, func) {
  try {
    return {
            TAG: /* Ok */0,
            _0: Curry._1(func, undefined)
          };
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.RE_EXN_ID === Js_exn.$$Error) {
      var errMsg = "" + title + ": " + Belt_Option.getWithDefault(exn._1.message, "unknown error.") + ".";
      return {
              TAG: /* Error */1,
              _0: errMsg
            };
    }
    var errMsg$1 = "" + title + ": unknown error.";
    return {
            TAG: /* Error */1,
            _0: errMsg$1
          };
  }
}

function reqExn(nullable, msg) {
  if (nullable == null) {
    return Js_exn.raiseError("A required attribute is missing: " + msg + "");
  } else {
    return nullable;
  }
}

var isString = (obj => typeof obj === 'string');

var isBool = (obj => typeof obj === 'boolean');

var isArray = (obj => Array.isArray(obj));

var isObject = (obj => obj !== undefined && obj !== null && !Array.isArray(obj) && typeof obj === 'object');

var isFunction = (obj => typeof obj === 'function');

function reqStrExn(nullable, msg) {
  var res = reqExn(nullable, msg);
  if (isString(res)) {
    return res;
  } else {
    return Js_exn.raiseError("Not a string: " + msg + "");
  }
}

function optStrExn(nullable, msg) {
  if (!(nullable == null)) {
    if (isString(nullable)) {
      return nullable;
    } else {
      return Js_exn.raiseError("Not a string: " + msg + "");
    }
  }
  
}

function reqBoolExn(nullable, msg) {
  var res = reqExn(nullable, msg);
  if (isBool(res)) {
    return res;
  } else {
    return Js_exn.raiseError("Not a boolean: " + msg + "");
  }
}

function optBoolExn(nullable, msg) {
  if (!(nullable == null)) {
    if (isBool(nullable)) {
      return nullable;
    } else {
      return Js_exn.raiseError("Not a boolean: " + msg + "");
    }
  }
  
}

function reqArrExn(nullable, msg) {
  var res = reqExn(nullable, msg);
  if (isArray(res)) {
    return res;
  } else {
    return Js_exn.raiseError("Not an array: " + msg + "");
  }
}

function reqObjExn(nullable, msg) {
  var res = reqExn(nullable, msg);
  if (isObject(res)) {
    return res;
  } else {
    return Js_exn.raiseError("Not an object: " + msg + "");
  }
}

function optObjExn(nullable, msg) {
  if (!(nullable == null)) {
    if (isObject(nullable)) {
      return Caml_option.some(nullable);
    } else {
      return Js_exn.raiseError("Not an object: " + msg + "");
    }
  }
  
}

function reqFuncExn(nullable, msg) {
  var res = reqExn(nullable, msg);
  if (isFunction(res)) {
    return res;
  } else {
    return Js_exn.raiseError("Not a function: " + msg + "");
  }
}

function syntaxTreeToSelection(tree) {
  var text = MM_syntax_tree.syntaxTreeToText(tree);
  var tmp;
  tmp = tree.TAG === /* Subtree */0 ? tree._0.children.map(syntaxTreeToSelection) : [];
  return {
          text: text,
          children: tmp
        };
}

function createTransformFromObject(obj) {
  return {
          canApply: (function (selection) {
              return obj.canApply(selection);
            }),
          displayName: (function (selection) {
              return obj.displayName(selection);
            }),
          createInitialState: (function (selection) {
              return obj.createInitialState(selection);
            }),
          renderDialog: (function (params) {
              return obj.renderDialog(params);
            })
        };
}

var stringToFragTransformsUnsafe = (body => new Function("", body)());

function stringToFragTransforms(str) {
  var transforms;
  try {
    transforms = {
      TAG: /* Ok */0,
      _0: stringToFragTransformsUnsafe(str)
    };
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    transforms = exn.RE_EXN_ID === Js_exn.$$Error ? ({
          TAG: /* Error */1,
          _0: Belt_Option.mapWithDefault(exn._1.message, "[1] Cannot parse transforms.", (function (msg) {
                  return "[1] Cannot parse transforms: " + msg + "";
                }))
        }) : ({
          TAG: /* Error */1,
          _0: "[2] Cannot parse transforms."
        });
  }
  try {
    if (transforms.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: transforms._0.map(createTransformFromObject)
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: transforms._0
            };
    }
  }
  catch (raw_exn$1){
    var exn$1 = Caml_js_exceptions.internalToOCamlException(raw_exn$1);
    if (exn$1.RE_EXN_ID === Js_exn.$$Error) {
      return {
              TAG: /* Error */1,
              _0: Belt_Option.mapWithDefault(exn$1._1.message, "[3] Cannot parse transforms.", (function (msg) {
                      return "[3] Cannot parse transforms: " + msg + "";
                    }))
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: "[4] Cannot parse transforms."
            };
    }
  }
}

function arrStrToFragTransforms(texts) {
  return texts.reduce((function (res, text) {
                if (res.TAG !== /* Ok */0) {
                  return res;
                }
                var msg = stringToFragTransforms(text);
                if (msg.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: res._0.concat(msg._0)
                        };
                } else {
                  return {
                          TAG: /* Error */1,
                          _0: msg._0
                        };
                }
              }), {
              TAG: /* Ok */0,
              _0: []
            });
}

function reactElemDtoToObj(prim) {
  return prim;
}

function objToObj(prim) {
  return prim;
}

function objToFragmentTransformState(prim) {
  return prim;
}

exports.reactElemDtoToObj = reactElemDtoToObj;
exports.objToObj = objToObj;
exports.objToFragmentTransformState = objToFragmentTransformState;
exports.unsafeFunc = unsafeFunc;
exports.isObject = isObject;
exports.reqStrExn = reqStrExn;
exports.optStrExn = optStrExn;
exports.reqBoolExn = reqBoolExn;
exports.optBoolExn = optBoolExn;
exports.reqArrExn = reqArrExn;
exports.reqObjExn = reqObjExn;
exports.optObjExn = optObjExn;
exports.reqFuncExn = reqFuncExn;
exports.syntaxTreeToSelection = syntaxTreeToSelection;
exports.arrStrToFragTransforms = arrStrToFragTransforms;
/* MM_syntax_tree Not a pure module */
